import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { Clock, AlertTriangle, Users, Zap } from "lucide-react";
const HerausforderungenSection = () => <IndustryChallengesI18n translationPrefix="industryMaschinenbau" icons={[Clock, AlertTriangle, Users, Zap]} />;
export default HerausforderungenSection;
